import React from "react";
import { makeStyles } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { tesaRed } from "../../styles/colors";

const useStyles = makeStyles({
  error: {
    color: `${tesaRed} !important`,
  },
  flexRow: {
    flexDirection: "row",
  },
  formLabel: {
    fontSize: "0.75rem",
    minHeight: "0.25rem",
  },
});

interface CustomRadioGroupProps extends RadioGroupProps {
  error?: boolean;
  disabled?: boolean;
  formLabel?: string;
  mandatory?: boolean;
  options: string[];
  optionLabel?: { [key: string]: string };
}

const CustomRadioGroup = (props: CustomRadioGroupProps) => {
  const classes = useStyles(props);
  const { defaultValue, error, disabled, formLabel, mandatory, name, onChange, options, value, optionLabel } = props;

  const serialize = (string: string) => {
    return string.toUpperCase().replace(/ /g, "_");
  };

  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel className={classes.formLabel} component="legend">
        {mandatory ? `${formLabel}*` : formLabel}
      </FormLabel>
      <RadioGroup
        aria-label="gender"
        className={[classes.flexRow, error && classes.error].join(" ")}
        defaultValue={defaultValue}
        name={name}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => {
          return (
            <FormControlLabel
              className={error ? classes.error : ""}
              value={serialize(option)}
              control={<Radio className={error ? classes.error : ""} />}
              label={optionLabel?.[option] || option}
              name={name}
              key={serialize(option)}
            />
          );
        })}
        {error && "Please make a selection"}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomRadioGroup;
